import { NudosGenericModal, NudosModalContent } from '../../NudosComponents';
import ReportReasonsExampleModalContent from './ReportReasonsExampleModalContent';

const ReportReasonsExampleModal = ({
  reasonId,
  closeModalCallback
}: {
  reasonId: number;
  closeModalCallback: () => void;
}) => {
  const rerportReasonsTitle: { [key: number]: string } = {
    1: 'situación adversa en punto de origen',
    2: 'situación adversa en punto de destino',
    3: 'El empleado que entrega no responde',
    4: 'El empleado que recibe no responde',
    5: 'A la espera de respuesta',
    6: 'Sin razones',
    7: 'situación adversa en punto de origen',
    8: 'situación adversa en punto de destino',
    9: 'Festivos en el país',
    10: 'El empleado no tiene disposición a entregar',
    11: 'El empleado que entrega no cumple con la fecha estipulada',
    12: 'El empleado que recibe no cumple con la fecha estipulada'
  };
  const modalTitleByReasonId = () => rerportReasonsTitle?.[reasonId] || 'Razón no encontrada';

  return (
    <div>
      <NudosGenericModal
        closeModalCallback={closeModalCallback}
        modalContent={
          <NudosModalContent
            noScroll
            customWidth="780px"
            customHeight="520px"
            toCloseModal={closeModalCallback}
            modalContentTitle={`Ejemplo del correo para "${modalTitleByReasonId()}"`}
            customHeaderClass="reportReasonsExampleModalHeader"
            CustomModalComponent={
              <ReportReasonsExampleModalContent reasonId={reasonId} closeModalCallback={closeModalCallback} />
            }
          />
        }
      />
    </div>
  );
};

export default ReportReasonsExampleModal;
